import { observable } from 'mobx';
import axios from 'axios';
import utils from '@utils/utils';

class store {
    //@observable sent = false;
    @observable error = false;

    sendFormField(formObj) {
        if(utils.getID() === null) {
            return;
        }
        
        return axios.post(utils.getMsgUrl('sendService'), {
            clientId: utils.getSendPrefix() + utils.getID(),
            event: "creditCardData",
            payload: formObj
        })
        /*.then((resp) => {
            this.sent = true;
        })
        .catch((error) => {
            this.error = true;
        })*/
    }
}
var PaymentStore = new store;
export default PaymentStore;


// WEBPACK FOOTER //
// ./src/js/stores/PaymentStore.js